module.exports = __webpack_public_path__ + "static/media/1_A1_20.e0d2b051.png";